export var DeviceScreenSize;
(function (DeviceScreenSize) {
    DeviceScreenSize[DeviceScreenSize["Mobile"] = 768] = "Mobile";
    DeviceScreenSize[DeviceScreenSize["Tablette"] = 1023] = "Tablette";
})(DeviceScreenSize || (DeviceScreenSize = {}));
export const footerConstants = {
    sizeMessageDebounceMs: 100,
    detailsOpeningAnimationDurationMs: 800,
    // Duration opacity longer than the opening animation duration to ensure that details are fully visible at the end of the animation
    detailsOpacityAnimationDurationMs: 900,
    detailsAnimationType: 'ease-in-out'
};
export const popinOptinConstants = {
    phoneNumberLength: 4,
    url: {
        getSubscriptionUrl: "subscriptions/info",
        updateSubscriptionUrl: "subscribe-newsletter",
    },
    dialogOptin: {
        type: 'dialog-optin',
        titleId: 'dialog-optin-title',
        descId: 'dialog-optin-desc',
    },
    dialogOptinCentered: {
        type: 'dialog-optin-centered',
        titleId: 'dialog-optin-centered-title',
        descId: 'dialog-optin-centered-desc',
    },
    closeCtaDefaultColor: '#000',
    defaultTextColor: '#121212',
};
export const privacyPolicyUrls = {
    fr: 'politique-de-confidentialite-des-donnees',
    de: 'datenschutzrichtlinie',
    es: 'politica-de-confidencialidad-de-datos',
    it: 'informativa-sulla-privacy-per-il-trattamento-dei-dati-personali',
    pt: 'politica-de-confidencialidade-dos-dados',
    nl: 'privacybeleid',
    en: 'privacy-policy',
};
export const termsUrls = {
    fr: 'conditions-generales-de-vente',
    es: 'condiciones-generales-de-venta',
    it: 'condizioni-generali-di-vendita',
    nl: 'algemene-verkoopvoorwaarden',
    pt: 'condicoes-gerais-de-venda',
    de: 'allgemeine-geschaeftsbedingungen',
    en: 'terms-conditions',
};
export const hspThreshold = 200;
